import { render, staticRenderFns } from "./deviceWarn.vue?vue&type=template&id=1b13012c&scoped=true&"
import script from "./deviceWarn.vue?vue&type=script&lang=js&"
export * from "./deviceWarn.vue?vue&type=script&lang=js&"
import style0 from "./deviceWarn.vue?vue&type=style&index=0&id=1b13012c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13012c",
  null
  
)

export default component.exports